<template>
<div></div>
</template>

<script>
export default {
name: "MyProceedsChartReport",
}
</script>

<style scoped>

</style>
